// layouts
import DashboardRoute from "routes/DashboardRoute";
import SignIn from "layouts/authentication/sign-in";
import Permissions from "layouts/permissions";
import PermissionsList from "layouts/permissions/PermissionsList";
import RolePermissions from "layouts/permissions/RolePermissions";
import AddParty from "layouts/parties";
import PartyList from "layouts/parties/PartyList";
import AddDistrict from "layouts/cities/AddDistrict";
import DistrictList from "layouts/cities/DistrictList";
import AddSubdistrict from "layouts/cities/addSubdistrict";
import SubdistrictList from "layouts/cities/SubdistrictList";
import AddCity from "layouts/cities/AddCity";
import CityList from "layouts/cities/CityList";
import AddWard from "layouts/cities/AddWard";
import WardList from "layouts/cities/WardList";
import AddUser from "layouts/cities/AddUser";
import UserList from "layouts/cities/UserList";
import EditUser from "layouts/cities/EditUser";
import AddDepartment from "layouts/departmentcategories/AddDepartment";
import DepartmentList from "layouts/departmentcategories/DepartmentList";
import AddCategory from "layouts/departmentcategories/AddCategory";
import CategoryList from "layouts/departmentcategories/CategoryList";
import AddUserLeader from "layouts/add_recepnist/AddUserLeader";
import WorkerList from "layouts/add_recepnist/WorkerList";
import AddComplaints from "layouts/complaints/AddComplaints";
import ComplaintList from "layouts/complaints/ComplaintList";
import AddHelpCategory from "layouts/departmentcategories/addHelpCategory";
import HelpCategoryList from "layouts/departmentcategories/HelpCategoryList";
import LetterTemplates from "layouts/helping_letters/AddLetterTemplate";
import LetterTemplateList from "layouts/helping_letters/LetterTemplateList";
import EditLetterTemplate from "layouts/helping_letters/EditLetterTemplate";
import AddTemplateField from "layouts/departmentcategories/AddTemplateField";
import CategoryFieldList from "layouts/departmentcategories/CategoryFieldList";
import EditCategoryField from "layouts/departmentcategories/EditCategoryField";
import GenerateLetter from "layouts/letter_genration/LeaderLetterGenerate";
import AddSource from "layouts/departmentcategories/AddSource";
import SourceList from "layouts/departmentcategories/SourceList";
import AddJantaDarbar from "layouts/complaints/AddJantadarbar";
import JanataDarbarList from "layouts/complaints/JanataDarbarList";
import EditJantaDarbar from "layouts/complaints/EditJantaDarbar";
import AddVillage from "layouts/cities/Villages";
import VillageList from "layouts/cities/VillageList";
import AddSchemes from "layouts/all_home_forms/AddSchemes";
import SchemeList from "layouts/all_home_forms/SchemeList";
import EditScheme from "layouts/all_home_forms/EditScheme";
import AddHeroSection from "layouts/all_home_forms/AddHeroSection";
import HeroSectionList from "layouts/all_home_forms/HeroSectionList";
import EditHeroSection from "layouts/all_home_forms/EditHeroSection";
import UpdateSectionHero from "layouts/all_about_forms/AllHeroSections";
import SectionHeroList from "layouts/all_about_forms/SectionHeroList";
import VisionMissionUpdate from "layouts/all_about_forms/VisionMissionUpdate";
import CoreValuesList from "layouts/all_about_forms/CoreValuesList";
import EditCoreValues from "layouts/all_about_forms/EditCoreValues";
import AddGalleryCategory from "layouts/all_gallery_page_forms/AddGalleryCategory";
import GalleryCategoryList from "layouts/all_gallery_page_forms/GalleryCategoryList";
import AddGallery from "layouts/all_gallery_page_forms/AddGallery";
import GalleryList from "layouts/all_gallery_page_forms/GalleryList";
import EditGallery from "layouts/all_gallery_page_forms/EditGallery";
import AboutSection from "layouts/all_home_forms/AboutSection";
import AddWork from "layouts/add_work/AddWork";
import ProjectList from "layouts/add_work/ProjectList";
import EditWork from "layouts/add_work/EditWork";
import GetSuggestions from "layouts/complaints/GetSuggestions";

// icons  
import Icon from "@mui/material/Icon";

// auth
import ProtectedRoute from "routes/ProtectedRoute";

const routes = [
  // 1. DASHBOARD
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <ProtectedRoute requiredPermission="view_dashboard">
        <DashboardRoute />
      </ProtectedRoute>
    ),
  },

  // 2. SYSTEM ADMINISTRATION (Super Admin Masters)
  {
    type: "collapse",
    name: "Permissions Master",
    key: "permissions",
    icon: <Icon fontSize="small">key</Icon>,
    route: "/list",
    requiredPermission: "manage_permissions",
    component: (
      <ProtectedRoute requiredPermission="manage_permissions">
        <PermissionsList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/permissions",
    requiredPermission: "manage_permissions",
    component: (
      <ProtectedRoute requiredPermission="manage_permissions">
        <Permissions />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Role Permissions",
    key: "role_permissions",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/role_permissions",
    requiredPermission: "manage_permissions",
    component: (
      <ProtectedRoute requiredPermission="manage_permissions">
        <RolePermissions />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Parties",
    key: "party",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/party-list",
    requiredPermission: "manage_parties",
    component: (
      <ProtectedRoute requiredPermission="manage_parties">
        <PartyList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/parties",
    requiredPermission: "manage_parties",
    component: (
      <ProtectedRoute requiredPermission="manage_parties">
        <AddParty />
      </ProtectedRoute>
    ),
  },

  // 3. USER & WORKER MANAGEMENT
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    requiredPermission: "manage_users",
    component: (
      <ProtectedRoute requiredPermission="manage_users">
        <UserList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_user",
    requiredPermission: "manage_users",
    component: (
      <ProtectedRoute requiredPermission="manage_users">
        <AddUser />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_user/:id",
    requiredPermission: "manage_users",
    component: (
      <ProtectedRoute requiredPermission="manage_users">
        <EditUser />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Worker Under Leader",
    key: "leader",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/worker_list",
    requiredPermission: "manage_worker",
    component: (
      <ProtectedRoute requiredPermission="manage_worker">
        <WorkerList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_worker",
    requiredPermission: "manage_worker",
    component: (
      <ProtectedRoute requiredPermission="manage_worker">
        <AddUserLeader />
      </ProtectedRoute>
    ),
  },

  // 4. LOCATION & AREA MASTERS
  {
    type: "collapse",
    name: "Districts",
    key: "districts",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/district-list",
    requiredPermission: "manage_subdistricts",
    component: (
      <ProtectedRoute requiredPermission="manage_subdistricts">
        <DistrictList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/districts",
    requiredPermission: "manage_subdistricts",
    component: (
      <ProtectedRoute requiredPermission="manage_subdistricts">
        <AddDistrict />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Sub Districts",
    key: "sub districts",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/subdistrict-list",
    requiredPermission: "manage_subdistricts",
    component: (
      <ProtectedRoute requiredPermission="manage_subdistricts">
        <SubdistrictList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/subdistricts",
    requiredPermission: "manage_subdistricts",
    component: (
      <ProtectedRoute requiredPermission="manage_subdistricts">
        <AddSubdistrict />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Cities",
    key: "cities",
    icon: <Icon fontSize="small">location_city</Icon>,
    route: "/city-list",
    requiredPermission: "manage_cities",
    component: (
      <ProtectedRoute requiredPermission="manage_cities">
        <CityList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/cities",
    requiredPermission: "manage_cities",
    component: (
      <ProtectedRoute requiredPermission="manage_cities">
        <AddCity />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Ward",
    key: "ward",
    icon: <Icon fontSize="small">holiday_village</Icon>,
    route: "/ward-list",
    requiredPermission: "manage_wards",
    component: (
      <ProtectedRoute requiredPermission="manage_wards">
        <WardList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/ward",
    requiredPermission: "manage_wards",
    component: (
      <ProtectedRoute requiredPermission="manage_wards">
        <AddWard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Area Under Ward",
    key: "add_village",
    icon: <Icon fontSize="small">push_pin</Icon>,
    route: "/village_list",
    requiredPermission: "manage_wards",
    component: (
      <ProtectedRoute requiredPermission="manage_wards">
        <VillageList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_village",
    requiredPermission: "manage_wards",
    component: (
      <ProtectedRoute requiredPermission="manage_wards">
        <AddVillage />
      </ProtectedRoute>
    ),
  },

  // 5. DEPARTMENT & CATEGORY MASTERS
  {
    type: "collapse",
    name: "Departments",
    key: "departments",
    icon: <Icon fontSize="small">domain</Icon>,
    route: "/department_list",
    requiredPermission: "manage_departments",
    component: (
      <ProtectedRoute requiredPermission="manage_departments">
        <DepartmentList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/departments",
    requiredPermission: "manage_departments",
    component: (
      <ProtectedRoute requiredPermission="manage_departments">
        <AddDepartment />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/category_list",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <CategoryList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/categories",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <AddCategory />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Source",
    key: "add_source",
    icon: <Icon fontSize="small">alt_route</Icon>,
    route: "/source_list",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <SourceList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_source",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <AddSource />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Help Category",
    key: "help_category",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/help_category_list",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <HelpCategoryList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/help_category",
    requiredPermission: "manage_categories",
    component: (
      <ProtectedRoute requiredPermission="manage_categories">
        <AddHelpCategory />
      </ProtectedRoute>
    ),
  },

  // 6. COMPLAINTS & GRIEVANCE MANAGEMENT
  {
    type: "collapse",
    name: "Complaints",
    key: "add_complaints",
    icon: <Icon fontSize="small">report_problem</Icon>,
    route: "/all_complaints",
    requiredPermission: "manage_complaints",
    component: (
      <ProtectedRoute requiredPermission="manage_complaints">
        <ComplaintList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_complaints",
    requiredPermission: "manage_complaints",
    component: (
      <ProtectedRoute requiredPermission="manage_complaints">
        <AddComplaints />
      </ProtectedRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Get All Suggestions",
  //   key: "get_suggestions",
  //   icon: <Icon fontSize="small">lightbulb</Icon>,
  //   route: "/get_suggestions",
  //   requiredPermission: "manage_suggestion",
  //   component: (
  //     <ProtectedRoute requiredPermission="manage_suggestion">
  //       <GetSuggestions />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    type: "collapse",
    name: "Janta Darbar",
    key: "add_janta_darbar",
    icon: <Icon fontSize="small">record_voice_over</Icon>,
    route: "/jantadarbar_list",
    requiredPermission: "manage_janta_darbar",
    component: (
      <ProtectedRoute requiredPermission="manage_janta_darbar">
        <JanataDarbarList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_janta_darbar",
    requiredPermission: "manage_janta_darbar",
    component: (
      <ProtectedRoute requiredPermission="manage_janta_darbar">
        <AddJantaDarbar />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_janata_darbar/:id",
    requiredPermission: "manage_janta_darbar",
    component: (
      <ProtectedRoute requiredPermission="manage_janta_darbar">
        <EditJantaDarbar />
      </ProtectedRoute>
    ),
  },

  // 7. LETTERS & COMMUNICATIONS
  {
    type: "collapse",
    name: "Letter Templates",
    key: "letter_templates",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/letter_template_list",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <LetterTemplateList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/letter_templates",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <LetterTemplates />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_letter_template/:id",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <EditLetterTemplate />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Template Field",
    key: "add_template_field",
    icon: <Icon fontSize="small">segment</Icon>,
    route: "/category_field_list",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <CategoryFieldList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_template_field",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <AddTemplateField />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_category_field/:id",
    requiredPermission: "manage_letter_template",
    component: (
      <ProtectedRoute requiredPermission="manage_letter_template">
        <EditCategoryField />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Generate Letter",
    key: "generate_letter",
    icon: <Icon fontSize="small">mark_email_read</Icon>,
    route: "/generate_letter",
    requiredPermission: "generate_letter",
    component: (
      <ProtectedRoute requiredPermission="generate_letter">
        <GenerateLetter />
      </ProtectedRoute>
    ),
  },

  // 8. PROJECTS & SCHEMES
  {
    type: "collapse",
    name: "Work / Projects",
    key: "add_work",
    icon: <Icon fontSize="small">construction</Icon>,
    route: "/projects",
    requiredPermission: "manage_projects",
    component: (
      <ProtectedRoute requiredPermission="manage_projects">
        <ProjectList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_work",
    requiredPermission: "manage_projects",
    component: (
      <ProtectedRoute requiredPermission="manage_projects">
        <AddWork />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_work/:id",
    requiredPermission: "manage_projects",
    component: (
      <ProtectedRoute requiredPermission="manage_projects">
        <EditWork />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Schemes",
    key: "add_schemes",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/scheme_list",
    requiredPermission: "manage_schemes",
    component: (
      <ProtectedRoute requiredPermission="manage_schemes">
        <SchemeList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_schemes",
    requiredPermission: "manage_schemes",
    component: (
      <ProtectedRoute requiredPermission="manage_schemes">
        <AddSchemes />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_scheme/:id",
    requiredPermission: "manage_schemes",
    component: (
      <ProtectedRoute requiredPermission="manage_schemes">
        <EditScheme />
      </ProtectedRoute>
    ),
  },

  // 9. WEBSITE CONTENT MANAGEMENT (CMS)
  {
    type: "collapse",
    name: "Hero Section",
    key: "add_hero_section",
    icon: <Icon fontSize="small">slideshow</Icon>,
    route: "/hero_section_list",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <HeroSectionList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_hero_section",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <AddHeroSection />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_hero_section/:id",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <EditHeroSection />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "See All Hero Sections",
    key: "section_hero_list",
    icon: <Icon fontSize="small">collections</Icon>,
    route: "/section_hero_list",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <SectionHeroList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/update_section_hero/:hero_id",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <UpdateSectionHero />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Update About Section",
    key: "update_about_section",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/update_about_section",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <AboutSection />
      </ProtectedRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Vision Mission Update",
  //   key: "vision_mission_update",
  //   icon: <Icon fontSize="small">visibility</Icon>,
  //   route: "/vision_mission_update",
  //   requiredPermission: "manage_content",
  //   component: (
  //     <ProtectedRoute requiredPermission="manage_content">
  //       <VisionMissionUpdate />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    type: "collapse",
    name: "See Core Values",
    key: "core_values_list",
    icon: <Icon fontSize="small">verified</Icon>,
    route: "/core_values_list",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <CoreValuesList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_core_value/:id",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <EditCoreValues />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Add Gallery Category",
    key: "add_gallery_category",
    icon: <Icon fontSize="small">style</Icon>,
    route: "/all_gallery_category",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <GalleryCategoryList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_gallery_category",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <AddGalleryCategory />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Add Gallery",
    key: "add_gallery",
    icon: <Icon fontSize="small">photo_camera</Icon>,
    route: "/all_gallery",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <GalleryList />
      </ProtectedRoute>
    ),
  },
  {
    route: "/add_gallery",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <AddGallery />
      </ProtectedRoute>
    ),
  },
  {
    route: "/edit_gallery/:id",
    requiredPermission: "manage_content",
    component: (
      <ProtectedRoute requiredPermission="manage_content">
        <EditGallery />
      </ProtectedRoute>
    ),
  },

  // 10. AUTHENTICATION
  {
    type: "authentication",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
